import Vue from 'vue';
import Vuex from 'vuex';
import {setToken, getToken, removeToken} from '@/utils/cookies'
import { 
  captcha, 
  passWordLogin,
  sendSmSCode,
  findPassword,
  checkMobile
} from '@/api/user'
Vue.use(Vuex);
const userInfo = getToken('DCI_USER') || JSON.stringify({
    token:'',
    mobile:''
})

const state = {
    userInfo: userInfo
}
const mutations = {
    setUserInfo(state, userInfo) {
		state.userInfo = userInfo;
		setToken('DCI_USER',userInfo);
  },
  loginout() {
		removeToken('DCI_USER')
	},
}
const actions = {
  LOGINPASSWORD({commit},params) {
      return new Promise((resolve) => {        
        passWordLogin(params).then(response => {
          if (response && response.code === 200) {
            commit('setUserInfo', JSON.stringify(response.data));
            resolve(response);
          }  
        })
      })
    },
    LOGINCAPTCHA({commit}, params) {
      return new Promise((resolve) => {        
        captcha(params).then(response => {
          if (response && response.code === 200) {
            commit('setUserInfo', JSON.stringify(response.data));
            resolve(response);
          }  
        })
      })
    },
    SEND_SMS_CODE(context, params) {
      return new Promise((resolve, reject) => {
        sendSmSCode(params).then(response => {
          if (response && response.code === 200)
            resolve(response);
        })
      })
    },
    FINDPASSWORD(context, params) {
      return new Promise((resolve, reject) => {
        findPassword(params).then(response => {
          if (response && response.code === 200)
            resolve(response);
        })
      })
    },   
    CHECKMOBILE(context, params) {
      return new Promise((resolve, reject) => {
        checkMobile(params).then(response => {
          if (response && response.code === 200)
            resolve(response);
        })
      })
    },
}
const getters = {  
    GET_USERINFO: state => {
        return state.userInfo || getToken('DCI_USER')
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}